<template>
  <div>
    <h3 class="header-title">Find Tutor Schedule</h3>
    <label>Let’s create your schedule for find tutor.</label>
    <br />
    <label>
      You have subscribed to the {{ user.packageName }} package, which is valid
      until {{ user.validTo }}. This subscription comes at a price of RM
      {{ user.invoiceprice }} and includes a limit of
      {{ check.NumberOfStudent }} students and
      <span v-if="check.TotalTeacher === 0">Unlimited</span
      ><span v-else>{{ check.TotalTeacher }} </span> teachers.
    </label>
    <br />
    <div class="custom-explore">
      <div>
        <CRow>
          <CCol sm="12">
            <div style="width: 80%" class="float-left">
              <img
                src="../assets/img/iconnoti.svg"
                class="ml-5 mr-2 mb-3 mt-3"
              />
              <span class="text-white mt-3 mb-2"> | </span>
              <label class="ml-2 text-white mt-3 mb-2"
                >Schedule For Find Tutor</label
              >
            </div>
            <div style="width: 20%" class="float-right p-0">
              <br /><br />
              <img
                src="../assets/img/icontriangle.svg"
                class="ml-5 mr-2"
                style="
                  position: absolute;
                  top: 0;
                  right: 100px;
                  bottom: 0;
                  height: 55px;
                "
              />
            </div>
          </CCol>
        </CRow>
      </div>
    </div>
    <br />
    <div v-if="user.validTo < currentDate" class="mt-2">
      <CAlert show color="danger">
        <CRow>
          <CCol sm="10">
            <strong class="text-danger mr-2"
              >X ERROR ! Your subscription package has expired. Please renew
              your current subscription or upgrade to a new package.
            </strong>
          </CCol>
          <CCol sm="2" class="text-right">
            <CButton type="button" class="custom-btn-navy" @click="GoToRenew()"
              >Renew</CButton
            >
          </CCol>
        </CRow>
      </CAlert>
    </div>
    <CCard>
      <CCol sm="12">
        <CRow class="pl-2 pt-2">
          <div>
            <br />
            <CRow>
              <CCol class="justify-content-center" sm="12" lg="12">
                <div>
                  <CRow>
                    <CCol sm="12">
                      <CAlert color="danger" closeButton v-if="errorModal == true"
                        >Error : Data Already Exist</CAlert
                      >
                      <CAlert color="success" closeButton v-if="successModal == true"
                        >Success: You have successfully save student
                        schedule.</CAlert
                      >
                    </CCol>
                  </CRow>
                  <CCol sm="12" lg="12">
                    <CRow>
                      <CCol sm="4" lg="4"> <label>Group</label></CCol>
                      <CCol sm="8" lg="8">
                        <input
                          @click="OpenOneToOne"
                          type="radio"
                          v-model="group"
                          value="OneToOne"
                          required
                        />
                        One To One
                        <input
                          @click="OpenGroupOfTwo"
                          type="radio"
                          class="text-dark ml-4"
                          v-model="group"
                          value="GroupOfTwo"
                          required
                        />
                        Group Of Two
                      </CCol>

                      <CCol v-if="OneToOneForm == true" sm="12" lg="12">
                        <CRow>
                          <CCol sm="4" lg="4" class="mt-3">
                            <label>Student</label></CCol
                          >
                          <CCol sm="8" lg="8">
                            <v-select
                              ref="select"
                              v-model="SelectedStudent"
                              :options="students"
                              label="Name"
                              placeholder="--Please Select Student Name--"
                              required
                            >
                              <span
                                slot="no-options"
                                @click="$refs.select.open = false"
                              >
                                Please Register Student
                              </span></v-select
                            >
                          </CCol>
                        </CRow>
                      </CCol>
                      <CCol v-if="GroupOfTwoForm == true" sm="12" lg="12">
                        <CRow>
                          <CCol sm="4" lg="4" class="mt-3">
                            <label>Student 1</label></CCol
                          >
                          <CCol sm="8" lg="8" class="mt-3">
                            <v-select
                              ref="select"
                              v-model="SelectedStudent"
                              :options="students"
                              label="Name"
                              placeholder="--Please Select Student Name--"
                              required
                            >
                              <span
                                slot="no-options"
                                @click="$refs.select.open = false"
                              >
                                Please Register Student
                              </span></v-select
                            >
                          </CCol>
                          <CCol sm="4" lg="4" class="mt-3">
                            <label>Student 2</label></CCol
                          >
                          <CCol sm="8" lg="8" class="mt-3">
                            <v-select
                              ref="select"
                              v-model="SelectedStudent2"
                              :options="students"
                              label="Name"
                              placeholder="--Please Select Student Name--"
                              required
                            >
                              <span
                                slot="no-options"
                                @click="$refs.select.open = false"
                              >
                                Please Register Student
                              </span></v-select
                            >
                          </CCol>
                        </CRow>
                      </CCol>

                      <CCol sm="4" lg="4" class="mt-3">
                        <label>Subject</label></CCol
                      >
                      <CCol sm="8" lg="8" class="mt-3">
                        <v-select
                          v-model="SelectedSubject"
                          :options="subjects"
                          label="SubjectName"
                          placeholder="--Please Select Subject--"
                          required
                        ></v-select>
                      </CCol>

                      <CCol sm="4" lg="4" class="mt-3">
                        <label>Grade</label></CCol
                      >
                      <CCol sm="8" lg="8" class="mt-3">
                        <v-select
                          v-model="SelectedGrade"
                          :options="grades"
                          label="GradeName"
                          placeholder="--Please Select Level--"
                          required
                        ></v-select>
                      </CCol>

                      <CCol sm="4" lg="4" class="mt-3">
                        <label>Language</label></CCol
                      >
                      <CCol sm="8" lg="8" class="mt-3">
                        <span v-for="item in languages" v-bind:key="item.Id">
                          <input
                            type="checkbox"
                            v-model="item.isAccepted"
                            class="mr-2 ml-2"
                          /><span class="text-dark">
                            {{ item.Name }}
                          </span>
                        </span>
                      </CCol>

                      <CCol sm="4" lg="4" class="mt-3">
                        <label>Session</label></CCol
                      >
                      <CCol sm="8" lg="8" class="mt-3">
                        <span
                          v-for="item in sessions"
                          v-bind:key="item.Id"
                          style="font-size: 15px"
                        >
                          <input
                            type="checkbox"
                            v-model="item.isAccepted"
                            class="mr-2 ml-2"
                          /><span class="text-dark">
                            {{ item.Name }}
                          </span>
                        </span>
                      </CCol>

                      <CCol sm="4" lg="4" class="mt-3">
                        <label>Time</label></CCol
                      >
                      <CCol sm="8" lg="8" class="mt-3">
                        <span
                          v-for="item in times"
                          v-bind:key="item.Id"
                          style="font-size: 15px"
                        >
                          <input
                            type="checkbox"
                            v-model="item.isAccepted"
                            class="mr-2 ml-2"
                          /><span class="text-dark">
                            {{ item.Name }}
                          </span>
                        </span>
                      </CCol>

                      <CCol sm="4" lg="4" class="mt-3">
                        <label>Class Duration</label></CCol
                      >
                      <CCol sm="8" lg="8" class="mt-3">
                        <span v-for="item in dur" v-bind:key="item.Id">
                          <input
                            name="item.Id"
                            type="radio"
                            value="item.Id"
                            v-model="durationID"
                            @change="durationID = item.Id"
                            class="mr-2 ml-2"
                          /><span class="text-dark">
                            {{ item.Name }}
                          </span>
                        </span>
                      </CCol>

                      <CCol sm="4" lg="4" class="mt-3">
                        <label>Teacher</label></CCol
                      >
                      <CCol sm="8" lg="8" class="mt-3">
                        <v-select
                          v-model="SelectedTeacher"
                          :options="list"
                          label="Name"
                          placeholder="--Please Select Teacher--"
                          required
                        ></v-select>
                      </CCol>

                      <CCol sm="4" lg="4" class="mt-3">
                        <label>Start Time</label></CCol
                      >
                      <CCol sm="8" lg="8" class="mt-3">
                        <CInput 
                          type="datetime-local" 
                          v-model="StartTime" 
                          :value="new Date(StartTime).toLocaleString()"
                        />
                      </CCol>
                    </CRow>
                  </CCol>
                </div>
              </CCol>
              <br />
            </CRow>
          </div>
          <div class="ml-3 mb-3">
            <CButton
              v-if="OneToOneForm == true"
              style="background: #1565d8"
              color="primary"
              @click="DirectOneToOne"
              >{{ lblMessage }}</CButton
            >

            <CButton
              v-if="GroupOfTwoForm == true"
              style="background: #1565d8"
              color="primary"
              @click="DirectGroupOfTwo"
              >{{ lblMessage }}</CButton
            >
          </div>
        </CRow>
        <CRow>
          <CCol sm="12">
            <CAlert color="danger" closeButton v-if="errorModal == true"
              >Error : Data Already Exist</CAlert
            >
            <CAlert color="success" closeButton v-if="successModal == true"
              >Success: You have successfully save student schedule.</CAlert
            >
          </CCol>
        </CRow>
      </CCol>
    </CCard>
  </div>
</template>
  
  
  <script>
import _ from "lodash";
import Vue from "vue";
Vue.use(require("vue-moment"));
import PulseLoader from "vue-spinner/src/PulseLoader.vue";
import $ from "jquery";

import vSelect from "vue-select";
Vue.component("v-select", vSelect);
import "vue-select/dist/vue-select.css";
import "vue-select/src/scss/vue-select.scss";

Vue.use(VuejsDialog);
import VuejsDialog from "vuejs-dialog";
import "vuejs-dialog/dist/vuejs-dialog.min.css";

export default {
  name: "Collapses",
  components: {
    PulseLoader,
  },
  data() {
    return {
      user: {},

      currentDate: new Date().toISOString().substring(0, 10),

      check: {},
      SelectedStudent: "",
      SelectedStudent2: "",
      SelectedSubject: "",
      SelectedTeacher: "",
      SelectedGrade: "",

      StartTime: "",
      group: "",
      durationID: "",

      languages: [],
      sessions: [],
      times: [],
      subjects: [],
      list: [],
      grades: [],
      dur: [],

      FTModal: false,

      OneToOneForm: true,
      GroupOfTwoForm: false,

      successModal: false,
      errorModal: false,
      lblMessage: "Proceed",
      students: []
    };
  },
  async mounted() {
    this.SessionUserIdNo();
    let isAuth = await this.UserAuth();

    if (isAuth) {
      this.Busy = false;
      await this.GetListOfTeacher();
      await this.GetListOfSubject();
      await this.GetGrade();
      await this.GetListChild();
      this.GetLanguages();
      this.GetSession();
      this.GetTimes();
      this.GetDurations();
    } else {
      this.GoToLogin();
    }
  },
  methods: {
    SessionUserIdNo() {
      return this.$API
        .get(this.$LoginUserDetailAdmin, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200) {
            this.user = response.data;
            this.GetCheckTc(this.user.tuitioncenter);
          }
        });
    },
    GetCheckTc(tuitioncenter) {
      return this.$API
        .get(this.$GetCheckTcPackage + "?TuitionCenterId=" + tuitioncenter, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200) {
            this.check = response.data;
          }
        });
    },
    OpenOneToOne() {
      this.OneToOneForm = true;
      this.GroupOfTwoForm = false;
    },
    OpenGroupOfTwo() {
      this.GroupOfTwoForm = true;
      this.OneToOneForm = false;
    },
    async GetLanguages() {
      return this.$API
        .get(this.$Languages)
        .then(
          function (response) {
            this.languages = response.data;
          }.bind(this)
        )
        .catch(function (error) {
          console.log(error.response);
        });
    },
    async GetSession() {
      return this.$API
        .get(this.$Sessions)
        .then(
          function (response) {
            this.sessions = response.data;
          }.bind(this)
        )
        .catch(function (error) {
          console.log(error.response);
        });
    },
    async GetTimes() {
      return this.$API
        .get(this.$Times)
        .then(
          function (response) {
            this.times = response.data;
          }.bind(this)
        )
        .catch(function (error) {
          console.log(error.response);
        });
    },
    async GetDurations() {
      return this.$API
        .get(this.$Durations)
        .then(
          function (response) {
            this.dur = response.data;
          }.bind(this)
        )
        .catch(function (error) {
          console.log(error.response);
        });
    },

    async GetListChild() {
      console.log("masuk");
      this.$API
        .get(this.$AllStudentName, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.students = response.data;
          }
        });
    },
    async GetListOfTeacher() {
      this.Busy = true;
      this.$API
        .get(this.$ListTeacher, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.Busy = false;
            this.list = response.data;
            this.FilterList = this.list;
          }
        });
    },
    async GetListOfSubject() {
      this.$API
        .get(this.$ListSubject, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.subjects = response.data;
          }
        });
    },
    async GetGrade() {
      this.$API
        .get(this.$ListGrade, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.grades = response.data;
          }
        });
    },

    DirectOneToOne() {
      this.lblMessage = "Processing";
      this.successModal = true;
      this.lblMessage = "Completed";
      const formData = new FormData();

      formData.append("IsGroup", false);
      formData.append("StudentId", this.SelectedStudent.Id);
      formData.append("TeachingSubjectId", this.SelectedSubject.Id);
      formData.append("TeachingGradeId", this.SelectedGrade.Id);
      formData.append("DurationId", this.durationID);
      formData.append("StartTime", this.StartTime);
      formData.append("DataMessage", this.SelectedSubject.SubjectName);
      formData.append("teacherId", this.SelectedTeacher.TeacherId);

      var combinedLanguage = [];
      for (let i in this.languages) {
        let item = this.languages[i];
        combinedLanguage.push({
          LanguageId: item.Id,
          IsAccept: item.isAccepted === undefined ? false : item.isAccepted,
        });
      }

      let languageData = JSON.stringify(combinedLanguage);
      formData.append("Language", languageData);

      var combinedSession = [];
      for (let i in this.sessions) {
        let item = this.sessions[i];
        combinedSession.push({
          SessionId: item.Id,
          IsAccept: item.isAccepted === undefined ? false : item.isAccepted,
        });
      }

      let sessionData = JSON.stringify(combinedSession);
      formData.append("Session", sessionData);

      var combinedTime = [];
      for (let i in this.times) {
        let item = this.times[i];
        combinedTime.push({
          TimeId: item.Id,
          IsAccept: item.isAccepted === undefined ? false : item.isAccepted,
        });
      }

      let timeData = JSON.stringify(combinedTime);
      formData.append("Time", timeData);

      return this.$API
        .post(this.$InsertDirectFindTutorOneToOne, formData, {
          withCredentials: true,
        })
        .then((response) => {
          if (
            response.status == 200 &&
            response.data != null &&
            response.data > 0
          ) {
           
            // this.$dialog.alert("Success saved find tutor").then(function () {});
          } else {
            this.errorModal = true;
          }
        })
        .catch((error) => {
          if (error.response) {
            console.log(error.response.status);
            this.Error = true;
            this.Message = error;
            this.Message = "Error";
          }
        });
    },
    DirectGroupOfTwo() {
      this.lblMessage = "Processing";
      this.successModal = true;
      this.lblMessage = "Completed";
      const formData = new FormData();

      formData.append("IsGroup", true);
      formData.append("StudentId", this.SelectedStudent.Id);
      formData.append("studentId2", this.SelectedStudent2.Id);
      formData.append("TeachingSubjectId", this.SelectedSubject.Id);
      formData.append("TeachingGradeId", this.SelectedGrade.Id);
      formData.append("DurationId", this.durationID);
      formData.append("StartTime", this.StartTime);
      formData.append("DataMessage", this.SelectedSubject.SubjectName);
      formData.append("teacherId", this.SelectedTeacher.TeacherId);

      var combinedLanguage = [];
      for (let i in this.languages) {
        let item = this.languages[i];
        combinedLanguage.push({
          LanguageId: item.Id,
          IsAccept: item.isAccepted === undefined ? false : item.isAccepted,
        });
      }

      let languageData = JSON.stringify(combinedLanguage);
      formData.append("Language", languageData);

      var combinedSession = [];
      for (let i in this.sessions) {
        let item = this.sessions[i];
        combinedSession.push({
          SessionId: item.Id,
          IsAccept: item.isAccepted === undefined ? false : item.isAccepted,
        });
      }

      let sessionData = JSON.stringify(combinedSession);
      formData.append("Session", sessionData);

      var combinedTime = [];
      for (let i in this.times) {
        let item = this.times[i];
        combinedTime.push({
          TimeId: item.Id,
          IsAccept: item.isAccepted === undefined ? false : item.isAccepted,
        });
      }

      let timeData = JSON.stringify(combinedTime);
      formData.append("Time", timeData);

      return this.$API
        .post(this.$InsertDirectFindTutorGrouping, formData, {
          withCredentials: true,
        })
        .then((response) => {
          if (
            response.status == 200 &&
            response.data != null &&
            response.data > 0
          ) {
           
            // this.$dialog.alert("Success saved find tutor").then(function () {});
          } else {
            this.errorModal = true;
          }
        })
        .catch((error) => {
          if (error.response) {
            console.log(error.response.status);
            this.Error = true;
            this.Message = error;
            this.Message = "Error";
          }
        });
    },
  },
};
</script>
  
  
  <style>
@import url("https://fonts.googleapis.com/css2?family=Open+Sans:wght@600&display=swap");
</style>
  
  
  
  